import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as actions } from "../store/modules/stamp";
import AppBar from "@material-ui/core/AppBar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    },
    ul: {
      margin: 0,
      padding: 0
    },
    li: {
      listStyle: "none"
    }
  },
  appBar: {
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  toolbar: {
    flexWrap: "wrap"
  },
  toolbarTitle: {
    flexGrow: 1
  },
  link: {
    margin: theme.spacing(1, 1.5)
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6)
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[200]
  },
  cardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginBottom: theme.spacing(2)
  },
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(8),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up("sm")]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6)
    }
  }
});

const stampcounts = [
  {
    title: "누적 스탬프",
    count: "0",
    full: false
  },
  {
    title: "사용한 스탬프",
    count: "0",
    full: false
  },
  {
    title: "사용 가능한 쿠폰",
    count: "0",
    full: true
  }
];

class Stamp extends Component {
  initialize = async () => {
    const { actions } = this.props;
    const { id, store } = this.props.match.params;
    actions.setCustomerId(id);

    await actions.getStore(store);
    await actions.getCustomer(id, store);
  };

  componentDidMount() {
    this.initialize();
  }

  render() {
    const classes = this.props.classes;
    const { customer, store, t } = this.props;

    stampcounts[0].title = t("total_stamp_name");
    stampcounts[1].title = t("used_stamp_name");
    stampcounts[2].title = t("usable_stamp_name");

    stampcounts[0].count = customer.total_stamp_count;
    stampcounts[1].count = customer.used_stamp_count;
    const usableCount = customer.total_stamp_count - customer.used_stamp_count
    stampcounts[2].count = Math.floor(
      usableCount / store.swap_count
    );

    return (
      <React.Fragment>
        <CssBaseline />

        <AppBar position="relative">
          <Toolbar>
            <Typography variant="h6" color="inherit" noWrap>
              First stamp
            </Typography>
          </Toolbar>
        </AppBar>

        {/* Hero unit */}
        <Container
          maxWidth="xs"
          component="main"
          className={classes.heroContent}
        >
          <Typography
            component="h1"
            variant="h3"
            align="center"
            color="textPrimary"
            gutterBottom
          >
            {store.name}
          </Typography>
          <Typography
            variant="h5"
            align="center"
            color="textSecondary"
            component="p"
          >
            1 {t("coupon_name")} == {store.swap_count} {t("stamp_name")}
          </Typography>
        </Container>
        {/* End hero unit */}
        <Container maxWidth="xs" component="main">
          <Grid container spacing={5} alignItems="flex-end">
            {stampcounts.map(tier => (
              // Enterprise card is full width at sm breakpoint
              <Grid
                item
                key={tier.title}
                xs={12}
                sm={tier.full === true ? 12 : 6}
                md={4}
              >
                <Card>
                  <CardHeader title={tier.title} />
                  <CardContent>
                    <div className={classes.cardPricing}>
                      <Typography
                        component="h2"
                        variant="h3"
                        color="textPrimary"
                      >
                        {tier.count}
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </React.Fragment>
    );
  }
}

export default connect(
  state => ({
    store: state.stamp.store,
    customerId: state.stamp.customerId,
    customer: state.stamp.customer
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch)
  })
)(withStyles(styles)(withTranslation()(Stamp)));
